import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogActionsProps,
  DialogContent,
  DialogContentProps,
  DialogProps,
  DialogTitle,
  DialogTitleProps,
  IconButton,
  IconButtonProps,
  Tooltip,
  TooltipProps,
} from "@mui/material";
import I18n from "i18n";
import { ReactNode, useState } from "react";

export interface SettingsButtonProps extends Omit<IconButtonProps, "children"> {
  icon?: ReactNode;
  title: string;
  children: ReactNode;
  dialogProps?: DialogProps;
  dialogTitleProps?: DialogTitleProps;
  dialogContentProps?: DialogContentProps;
  dialogActionsProps?: DialogActionsProps;
  tooltipProps?: TooltipProps;
}

const SettingsButton: React.FC<SettingsButtonProps> = ({
  icon = <SettingsIcon />,
  title,
  children,
  dialogProps,
  dialogTitleProps,
  dialogContentProps,
  dialogActionsProps,
  tooltipProps,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={title} {...tooltipProps}>
        <IconButton onClick={handleClickOpen} {...props}>
          {icon}
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        {...dialogProps}
      >
        <DialogTitle {...dialogTitleProps}>
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers {...dialogContentProps}>
          {children}
          <Alert severity="info" sx={{ mt: 3 }}>
            A beállítások egyenlőre csak az adott böngészőben tárolódnak. Másik
            bengésző vagy eszköz használatakor újra be kell állítani.
          </Alert>
        </DialogContent>
        <DialogActions {...dialogActionsProps}>
          <Button onClick={handleClose} color="primary">
            {I18n.t("App.close")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SettingsButton;
